/**
 * Created by Arif Topcu in 2019
 */

import React, { memo } from "react";
import PropTypes from "prop-types";
import styles from "./BetaSelection.module.css";
import MiniBetasSelectorComplication from "./MiniBetasSelectorComplication";
import Icon from "react-icons-kit";
import { ic_add } from "react-icons-kit/md/ic_add";
import { ic_clear } from "react-icons-kit/md/ic_clear";
import Button from "@ls/react-button";
import CovarianceType from "state/selections/Constants/CovarianceType";
import PivotBetaDefinition from "state/pivots/PivotBetaDefinition";

const BetaSelection = ({ definition, setNewBeta, deleteBeta }) => {
  const { betaDefinitions } = definition;
  return (
    <div className={styles.root}>
      <div className={styles.betaDefinitions}>
        {betaDefinitions.map((betaDefinition, idx) => {
          return (
            <div className={styles.betaDefinition} key={idx}>
              <div className={styles.closeButton}>
                <Button
                  icon={
                    <Icon
                      icon={ic_clear}
                      size={16}
                      style={{ color: "#464646" }}
                    />
                  }
                  size="S"
                  onButtonClick={() => deleteBeta(idx)}
                  variation={5}
                />
              </div>
              <MiniBetasSelectorComplication
                setNewBeta={(betaDef) => setNewBeta(idx, betaDef)}
                betaDefinition={betaDefinition}
              />
            </div>
          );
        })}
      </div>
      <div
        className={styles.addMoreButton}
        onClick={() =>
          setNewBeta(
            betaDefinitions.length,
            new PivotBetaDefinition({
              betaId: 3,
              covarianceType: CovarianceType.HIST.value,
            })
          )
        }
      >
        <Icon icon={ic_add} style={{ display: "flex", alignItems: "center" }} />
        <div>Add Beta</div>
      </div>
    </div>
  );
};

BetaSelection.propTypes = {
  definition: PropTypes.object.isRequired,
  setNewBeta: PropTypes.func.isRequired,
  deleteBeta: PropTypes.func.isRequired,
};

export default memo(BetaSelection);
